import React, { useState,useEffect } from 'react';
import {
    formatPrice
  } from "@/helpers/pdpHelpers/priceHelpers";
import { formatDate } from '@/helpers/pdpHelpers/dateHelpers';
import OlivelaLogo from '@/components/Logos/OlivelaLogo';
import { getOrderStatus, shopifyOrderStatusColors } from '@/helpers/orderHelper';

const OrderTile = (props) => {
  const { styles,order } = props;
  const [order_status, setOrderStatus] = useState('');
  const [shopify_order_status, setShopifyOrderStatus] = useState('');
  const getStatus=async()=>{
    let order_status_array = await getOrderStatus(order);
    setOrderStatus(order_status_array.formattedOrderstatus);
    setShopifyOrderStatus(order_status_array.status);
  }
  useEffect(()=>{
    getStatus()
  }, [order.fulfillmentStatus]);
  let order_label = order.item_count == 1? '1 item':order.item_count+' items';
    return(
    <div className={`${styles.order_card}`}>
          <div className={`${styles.order_content}`}>
          {order_status && <div className={`${styles.order_item}`}>
               <div className={`${styles.status_wrapper}`}>		
                  <span className='x-small-xs x-small-sm small-md medium'>
                    {order_status}
                  </span>
                  <span className="status_rep" style={{backgroundColor:shopifyOrderStatusColors[shopify_order_status.toLocaleLowerCase()] || '#000000'}}>
                  </span>
                </div>
            </div>}
            <div className={`${styles.order_item}`}>
              <div className={`x-small-xs x-small-sm small-md ${styles.order_item_title}`}>Order #</div> 
              <div className={`${styles.order_item_detail}`} >
                <span className='xx-small-xs xx-small-sm x-small-md medium-md' tabIndex={0} onClick={() => {props.setActiveOrder(`${order.id}`);props.activeTab('orderDetailsTab')}}>{`${order.name.replace('#', '')}`} | {`${order_label}`}</span> 
                </div>
            </div>
            <div className={`${styles.order_item}`}>
              <div className={`x-small-xs x-small-sm small-md ${styles.order_item_title}`}>Date</div>
              <div className={`${styles.order_item_detail}`}>
                <span className='xx-small-xs xx-small-sm x-small-md'>
                  {`${formatDate(order?.processedAt)}`}
                </span>
                </div>
            </div>
            <div className={`${styles.order_item}`}>
              <div className={`x-small-xs x-small-sm small-md ${styles.order_item_title}`}>Total</div>
              <div className={`${styles.order_item_detail}`}>
                <span className='xx-small-xs xx-small-sm x-small-md'>
                  {`${formatPrice(order?.currentTotalPrice)}`}
                </span>
                </div>
            </div>
          </div>
          <div className={`${styles.order_image} ${order?.item_image ? '' : `${styles.no_image}` }`}>
            <div className={`${styles.order_image_card}`} tabIndex={0} onClick={() => {props.activeTab('orderDetailsTab');props.setActiveOrder(`${order.id}`)}}>
              {
                order?.item_image 
                ? <img src={`${order?.item_image}`} />
                : <OlivelaLogo className={styles.olivela_logo} />

              }
            </div>
            <div className={`${styles.order_action}`}><a tabIndex={0} className='x-small-md x-small-sm xx-small-xs' onClick={() => {props.setActiveOrder(`${order.id}`);props.activeTab('orderDetailsTab')}} >View order<img alt="right-arrow" src={`${process.env.NETLIFY_URL}/icons/Arrow/Right/large.svg?dark`} /></a></div>
          </div>
        </div>
  )
}

export default OrderTile